import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Container,
  Menu,
  MenuItem,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { ReactComponent as ExportIcon } from "../../../images/exportIcon.svg";
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
// import CodeEditorNew from './BlackScreenNew';
// import LikeDislikeComponent from './CommonLikeDislikeComponent';
import { TestCaseFlowDataContext } from "../../main-pages/TestAutomationPage";
import { useNavigate, useLocation } from "react-router-dom";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import CodeEditor from "../../output-components/test-automation/CodeEditor";
import CommonCopy from "../../custom-components/CommonCopy";

import {
  featureFiles,
  robotFilesService,
  robotFrameworkProject,
} from "../../../services/webServices";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SuccessPopup from "../../output-components/test-automation/SuccessPopup";
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";

const IconComponent = () => (
  <Box sx={{ maxWidth: 14, display: "flex", flexDirection: "column" }}>
    <img
      loading="lazy"
      src="https://cdn.builder.io/api/v1/image/assets/TEMP/74001bbbe35d84ed7dd44adbf23d2273b030df4d38296f54b84768e53b777ae2?placeholderIfAbsent=true&apiKey=61dcb7c26aae4febb0f66efb27027a73"
      alt=""
      style={{ width: "100%", objectFit: "contain" }}
    />
  </Box>
);

const RobotFile = (props) => {
  // console.log(props, "robotFilerobotFilerobotFile");
  const navigate = useNavigate();
  const location = useLocation();
  const [downloadOpen, setDownloadOpen] = useState(false);
  // const { pageClass, stepDefinition } = useContext(TestCaseFlowDataContext);
  // const { featureFiles } = useContext(TestCaseFlowDataContext);
  const [robotFiles, setRobotFiles] = useState(props.robotFile);
  const [RobotFrameworkGenerated, setRobotFrameworkGenerated] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  // const pageClass = props.pageClass;
  // const featureFiles = props.featureFile;
  // const [pageClassData, setpageClassData] = useState(props.pageClass);
  // const setLoading = useContext(LoadingModalContext);
  // const [liked, setLiked] = useState(false);
  // const [disliked, setDisliked] = useState(false);

  const [activeThumb, setActiveThumb] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const { setLoadingState } = useContext(LoadingModalContext);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false); // State to control the SuccessPopup
  const isDisabled = true;
  const [zipBlob, setZipBlob] = useState(null); // ⬅ store zip here

  // const defaultPageClassExpanded = pageClass !== "" && pageClass.length > 0 && stepDefinition === "";

  // useEffect(() => {
  //     setpageClassData(pageClass)
  // }, [pageClass])
  const [scmAnchorEl, setScmAnchorEl] = useState(null);
  const [selectedScm, setSelectedScm] = useState("");

  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  //   import JSZip from "jszip";
  // import { saveAs } from "file-saver";

  // const handleRobotFrameworkProject = async () => {
  //   let fake;

  //   // Progress animation
  //   const startProgress = (setProgress) => {
  //     let progress = 0;
  //     let stop = false;

  //     const interval = setInterval(() => {
  //       if (stop) return;
  //       progress += 0.3;
  //       if (progress > 98) progress = 98;
  //       setProgress((prev) => ({
  //         ...prev,
  //         progress: Math.floor(progress),
  //       }));
  //     }, 200);

  //     return {
  //       stop: () => {
  //         stop = true;
  //         clearInterval(interval);
  //       },
  //       completeTo100: async () => {
  //         stop = true;
  //         clearInterval(interval);
  //         setProgress((prev) => ({ ...prev, progress: 100 }));
  //         await new Promise((res) => setTimeout(res, 400));
  //       },
  //     };
  //   };

  //   // Start loader
  //   setLoadingState({
  //     open: true,
  //     message: "Generating Robot Framework project...",
  //     progress: 0,
  //   });

  //   fake = startProgress(setLoadingState);

  //   try {
  //     // ✅ Fetch JSON response (your provided structure)
  //     const totalData = await robotFrameworkProject(props);

  //     // ✅ Initialize ZIP
  //     const zip = new JSZip();
  //     const root = zip.folder("RobotFramework_Project");

  //     // ✅ Recursively build ZIP content
  //     const addContent = (folder, data) => {
  //       for (const [key, value] of Object.entries(data)) {
  //         if (typeof value === "object" && !Array.isArray(value)) {
  //           // Detect file-like entries (contains text/string content)
  //           const isFileObject =
  //             Object.values(value).every((v) => typeof v === "string");

  //           if (isFileObject) {
  //             for (const [fileName, fileContent] of Object.entries(value)) {
  //               folder.file(fileName, fileContent || "");
  //             }
  //           } else {
  //             // Subfolder
  //             const subFolder = folder.folder(key);
  //             addContent(subFolder, value);
  //           }
  //         } else {
  //           // Direct file at root (like .gitignore or README.md)
  //           folder.file(key, value || "");
  //         }
  //       }
  //     };

  //     addContent(root, totalData);

  //     // ✅ Generate ZIP as blob
  //     const zipBlob = await zip.generateAsync({ type: "blob" });

  //     // ✅ Trigger immediate download
  //     await fake.completeTo100();
  //     saveAs(zipBlob, "RobotFramework_Project.zip");

  //     // Optional UI updates
  //     setOpenSuccessPopup(true);
  //     setZipBlob(zipBlob);
  //   } catch (error) {
  //     console.error("❌ Error generating Robot Framework project:", error);
  //     setLoadingState({ open: false, message: "", progress: null });
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };

  const handleRobotFrameworkProject = async () => {
    console.log("calling download projecttt");
    let progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 60000 })
    progressHandler.start("Generating Robot Framework Project")
    try {
 
      const projectFilesResponse = await robotFrameworkProject(props);
      const projectData = projectFilesResponse.data;
      console.log(projectData, "projectDataprojectData");
 
      const addFiles = (folder, data) => {
        for (const [key, value] of Object.entries(data)) {
          if (typeof value === "string") {
            folder.file(key, value);
          } else if (typeof value === "object" && value !== null) {
            const subFolder = folder.folder(key);
            addFiles(subFolder, value);
          }
        }
      };
 
      const zip = new JSZip();
 
      // Add each top-level folder
      if (projectData.Executions) addFiles(zip.folder("Executions"), projectData.Executions);
      if (projectData.Global) addFiles(zip.folder("Global"), projectData.Global);
      if (projectData.Keywords) addFiles(zip.folder("Keywords"), projectData.Keywords);
      if (projectData.Library) addFiles(zip.folder("Library"), projectData.Library);
      if (projectData.ObjectRepository) addFiles(zip.folder("ObjectRepository"), projectData.ObjectRepository);
      if (projectData.Testdata) addFiles(zip.folder("Testdata"), projectData.Testdata);
      if (projectData.Tests) addFiles(zip.folder("Tests"), projectData.Tests);
 
      // Root-level files
      if (projectData[".gitignore"]) zip.file(".gitignore", projectData[".gitignore"]);
      if (projectData["build.bat"]) zip.file("build.bat", projectData["build.bat"]);
      if (projectData["README.md"]) zip.file("README.md", projectData["README.md"]);
      if (projectData["Requirements.txt"]) zip.file("Requirements.txt", projectData["Requirements.txt"]);
 
      // Generate and download the ZIP
      zip.generateAsync({ type: "blob" }).then((content) => {
        setZipBlob(content); // store in local state
        saveAs(content, "RobotFramework_Project.zip");
      });
 
      await progressHandler.finishAndClose();
    } catch (error) {
      console.error("Project generation error:", error);
      const errorMsg =
        error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  };
 

  // SCM Dropdown handlers
  const handleScmMenuOpen = (event) => {
    setScmAnchorEl(event.currentTarget);
  };

  const handleScmMenuClose = () => {
    setScmAnchorEl(null);
  };

  const handleScmSelection = (scmType) => {
    setSelectedScm(scmType);
    handleScmMenuClose();

    if (!zipBlob) {
      console.error("ZIP file not generated yet.");
      return;
    }

    // Navigate based on selected SCM
    if (scmType === "github") {
      navigate(`/dashboard/test-automation/newproject-gitcredentials`, {
        state: {
          framework: props.framework,
          projectType: props.projectType,
          zipFile: zipBlob,
        },
      });
    } else if (scmType === "bitbucket") {
      navigate(`/dashboard/test-automation/newproject-bitbucketcredentials`, {
        state: {
          framework: props.framework,
          projectType: props.projectType,
          zipFile: zipBlob,
        },
      });
    }
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const handleThumbClick = (thumbType) => {
    // Toggle thumbs based on the thumbType (like or dislike)
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };

  return (
    <>
      <Box>
        <CommonAccordion
          summary={"Robot File"}
          details={
            <Box>
              <CodeEditor
                codeContent={props.robotFile}
                setCodeContent={props.setRobotFile}
              />
              <Container maxWidth={false} disableGutters>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="flex-start"
                  maxWidth="557px"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                      marginTop: 2,
                    }}
                  >
                    <Tooltip title="Like" arrow>
                      <Box
                        onClick={() => handleThumbClick("like")}
                        sx={{
                          cursor: "pointer",
                          marginRight: 2, // Margin between the buttons
                          "&:hover": {
                            color: "#49A3FF", // Change color on hover
                          },
                        }}
                      >
                        {activeThumb === "like" ? (
                          <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                        ) : (
                          <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                        )}
                      </Box>
                    </Tooltip>

                    {/* Thumbs Down Button with Tooltip */}
                    <Tooltip title="Dislike" arrow>
                      <Box
                        onClick={() => handleThumbClick("dislike")}
                        sx={{
                          cursor: "pointer",
                          marginRight: 2, // Margin between the buttons
                          "&:hover": {
                            color: "#FF4842", // Change color on hover
                          },
                        }}
                      >
                        {activeThumb === "dislike" ? (
                          <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                        ) : (
                          <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                        )}
                      </Box>
                    </Tooltip>
                    <CommonCopy contentToCopy={props.robotFile} />
                  </Box>
                </Box>
              </Container>
            </Box>
          }
          buttons={[
            {
              label: "Download",
              onClick: handleDownloadClick,
              variant: "text",
              startIcon: <SaveAltRoundedIcon />,
              sx: { textTransform: "none" },
            },
            {
              label: "Download Robot Project",
              variant: "contained",
              onClick: handleRobotFrameworkProject,
              startIcon: <GenerateButton />,
              sx: { float: "right" },
            },
            {
              label: "Push to SCM Project",
              variant: "contained",
              disabled: !zipBlob,
              onClick: handleScmMenuOpen, // Open dropdown instead of direct navigation
              startIcon: <GenerateButton />,
              sx: { float: "right" },
            },
          ]}
          fullScreenMode={true}
          type={"output"}
          defaultExpanded={true}
        ></CommonAccordion>

        {/* SCM Selection Dropdown Menu */}
        <Menu
          anchorEl={scmAnchorEl}
          open={Boolean(scmAnchorEl)}
          onClose={handleScmMenuClose}
          PaperProps={{
            style: {
              width: "200px",
            },
          }}
        >
          <MenuItem
            onClick={() => handleScmSelection("github")}
            sx={{
              padding: "10px 16px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            GitHub
          </MenuItem>
          <MenuItem
            onClick={() => handleScmSelection("bitbucket")}
            sx={{
              padding: "10px 16px",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Bitbucket
          </MenuItem>
        </Menu>

        <CommonDownload
          open={downloadOpen}
          onClose={handleCloseDownload}
          serviceResponse={[
            { heading: "Robot File", type: "text", data: props.robotFile },
          ]}
          serviceName="Robot File"
          wordData={[
            { heading: "Robot File", type: "text", data: props.robotFile },
          ]}
          documents={["docx"]}
        />
      </Box>
      <SuccessPopup
        open={openSuccessPopup}
        handleClose={() => setOpenSuccessPopup(false)}
        text={"Robot"}
      />
    </>
  );
};

export default RobotFile;
